<template>
  <div :class="{'hidden':hidden}" class="page-box" v-if="yorn" ref="pageBox">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="pageChange"/>
  </div>
</template>

<script>

export default {
  name: 'Pagination',
  data(){
    return{
      yorn:true,
    }
  },
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 50
    },
    pageSizes: {
      type: Array,
      default() {
        return [50, 100, 150, 200]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log("pageSize")
      this.yorn = false;
      this.$emit('pageChange', { page: 1, limit: val })
      this.$nextTick(function () {
        this.yorn = true;
      })
    },
    pageChange(val) {
      console.log("pagenum")
      this.$emit('pageChange', { page: val, limit: this.pageSize })
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}
</style>
